import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router";

import { AdminContext } from "context/AdminContext";
import { SidebarContext } from "context/SidebarContext";
import AdminServices from "services/AdminServices";
import { notifyError, notifySuccess } from "utils/toast";

const useStaffSubmit = (id) => {
  const { state } = useContext(AdminContext);
  const { adminInfo } = state;
  const id_employee = adminInfo.id;
  const { isDrawerOpen, closeDrawer, setIsUpdate } =
    useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState(0);
  const [, setImageUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedState, setSelectedState] = useState([]);
  const [selectedAllCityinState, setSelectedAllCityinState] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [profileName, setProfileName] = useState("");
  const [existingId, setExisitingId] = useState("");
 const [selectedRoleId, setSelectedRoleId] = useState(null);
const [selectedRoleName, setSelectedRoleName] = useState("");

  const location = useLocation();
    useEffect(() => {
    if (!isDrawerOpen) {
      resetForm();
    
      return;
    }

    if (id) {
      getStaffData();
    }
  }, [isDrawerOpen, id]);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    trigger,
    formState: { errors },
    watch,
    reset
  } = useForm();

    const resetForm = () => {
    reset();
    setSelectedState([]);
    setSelectedAllCityinState([]);
    setSelectedCities([]);
    setProfileName("");
    setExisitingId("");
    setSelectedRoleId(null);
    setSelectedRoleName("");
    setStatus(0);
  };

  useEffect(() => {
  const subscription = watch((value, { name }) => {
    if (name === "regional_head_id") {
      // console.log(" Current Regional Head ID:", value.regional_head_id);
    }
  });
  return () => subscription.unsubscribe();
}, [watch]);

useEffect(() => {
  if (profileName && selectedRoleId) { 
    setSelectedRoleName(profileName.toLowerCase());
  }
}, [profileName, selectedRoleId]);
  const onSubmit = async (data) => {
   
    setLoading(true);
    try {
      setIsSubmitting(true);
      const stateIds = selectedState.map((state) => {
        if (typeof state === 'string') {
          return parseInt(state, 10); 
        }
        if (typeof state === 'object' && state.value) {
          return parseInt(state.value, 10);
        }
        return null;
      }).filter(Boolean); 
      
      const allcitystateIds = selectedAllCityinState.map((state) => {
        if (typeof state === 'string') {
          return parseInt(state, 10);
        }
        if (typeof state === 'object' && state.value) {
          return parseInt(state.value, 10);
        }
        return null;
      }).filter(Boolean);

      const staffData = {
        firstname: data.firstname,
        lastname:data.lastname,
        email: data.email,
        password: data.password_update,
        password_update: data.password_update,
        mobile: data.mobile,
        status: 'Active',
        id_profile: data.id_profile,
        state: stateIds,
        all_city_in_state: allcitystateIds,
        city:selectedCities,
        id_employee: id_employee,
        regional_head_id:data.regional_head_id || null
      };

      if (id) {
        const res = await AdminServices.updateStaff(id, staffData);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
          resetForm();
        closeDrawer();
      } else {
        const res = await AdminServices.addStaff( staffData );
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
          resetForm();
        closeDrawer();
      }
    } catch (err) {
      const errorMessage =
      err?.response?.data?.message?.message || err?.response?.data?.message || err?.message || "An unknown error occurred";
      notifyError(errorMessage); 
      setIsSubmitting(false);
    //  closeDrawer();
    }
    finally{
      setLoading(false);
    }
  };

  const getStaffData = async () => {
    try {
      const res = await AdminServices.getStaffById(id, {
        email: adminInfo.email,
      });
      if (res) {
        setValue("firstname", res.firstname);
        setValue("lastname",res.lastname);
        setValue("email", res.email);
        setValue("password_update",res.password_update);
        setValue("mobile", res.mobile);
        setValue("id_profile", res.id_profile);
        setValue("regional_head_id", res.regional_head);

        setStatus(res.status === 'Active'? true : false);
          setTimeout(() => {
            setValue("all_city_in_state", res.all_city_in_state);
            setSelectedCities(res.city);
            setValue("city", res.city);
          }, 500);
   setProfileName(res.profile_name);
   setExisitingId(res.regional_head);
   setSelectedRoleId(res.id_profile);
        setValue("state", res.state);
        setSelectedState(res.state);
        setSelectedCities(res.city);
        setSelectedAllCityinState(res.all_city_in_state);
        setImageUrl(process.env.REACT_APP_API_IMAGE_URL+res.emp_image);
        
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      setSelectedAllCityinState([]);
      setSelectedCities([]);
      setSelectedState([]);
      setValue("firstname");
      setValue("lastname");
      setValue("email");
      setValue("password_update");
      setValue("mobile");
      setValue("id_profile");
      setValue("regional_head_id");

      setValue("state");
      setValue("all_city_in_state");
      setValue("city");
      clearErrors();
      return;
    }
      
    if (id) {
      getStaffData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, setValue, isDrawerOpen, adminInfo.email, clearErrors]);

  useEffect(() => {
    if (location.pathname === "/edit-profile" && localStorage.getItem("adminInfo")) {
      getStaffData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, setValue]);

  return {
    trigger,
    register,
    handleSubmit,
    selectedCities,
    setSelectedCities,
    onSubmit,
    status,
    setStatus,
    errors,
    loading,
    setLoading,
    setSelectedState,
    selectedState,
    isSubmitting,
    selectedAllCityinState, setSelectedAllCityinState,profileName,watch,setValue,existingId,selectedRoleId,setSelectedRoleId
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
  };                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
};

export default useStaffSubmit;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          